import Model from './Model';

export default class Product extends Model {};